export default "__VITE_ASSET__BYLrINJ5__"